import React, { Component } from 'react'

class Filters extends Component {
  render () {
    return (
      <section className="row filters no-gutters">
        <div className="col-sm-12 col-md-12">
          <div className="input-group">
            <input
              type="text"
              name="keyword"
              id="academy-keyword"
              placeholder={this.props.i18n.t("academies.filter.searchPlaceholder")}
              value={this.props.keyword}
              onChange={this.props.updateKeywordState}
            />
            <div className="input-group-append">
              <span className="input-group-text"><i className="fa fa-search"></i></span>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default Filters;
